import { Tooltip, useDisclosure } from '@chakra-ui/react'
import React, { useContext } from 'react'
import { ButtonHeaderModule } from 'styled/Buttons.styled'
import { IconGeneric } from 'styled/Icons.styled'
import { MdContentCopy, MdOutlineAssignmentReturn } from 'react-icons/md'
import { FaHistory } from 'react-icons/fa'

import { AuthContext } from 'context/AuthContext'
import FormCrudCRUDContext from 'context/FormCrudContex'
import { localPermissions } from 'Permissions/permissions'
import { useSelector } from 'react-redux'
import { hasCommonElements } from 'utils/type-check-utils'
import { useGlobalLoading } from 'utils/globalLoading'
import ModalReturnHistory from 'components/modal/ModalReturnHistory'

export const ShowBtnCaducado = ({ handleCopy, data }) => {
  const { authUser } = useContext(AuthContext)
  const { onOpenDesCaducar } = useContext(FormCrudCRUDContext)
  const { isOpen: isOpenReturnHistory, onOpen: onOpenReturnHistory, onClose: onCloseReturnHistory } = useDisclosure()
  
  const handleDescaducar = () => {
    // setDataToCaducar(data);
    onOpenDesCaducar()
  }

  const { permissionList } = useSelector(state => state.permissions)
  const { changeStatus: changeStatusOutputForm, copy: copyOutputForm } =
    localPermissions.Outputform

  const { isLoading: isLoadingButton } = useGlobalLoading()

  return (
    <>
      <ModalReturnHistory
        isOpen={isOpenReturnHistory}
        onClose={onCloseReturnHistory}
        onOpen={onOpenReturnHistory}
        title={'Historial de Devoluciones'}
        size={'3xl'}
        entryFormId={data?.id}
        isOutputForm={true}
      />
      {data?.reason_for_return && (
        <Tooltip placement='top' hasArrow label='Historial de Devoluciones'>
          <span>
            <ButtonHeaderModule
              onClick={onOpenReturnHistory}
              bgColor='#FF9800'
              className='me-1'
              isLoading={isLoadingButton}
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={FaHistory}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}
      {(hasCommonElements(permissionList, copyOutputForm) ||
        authUser.admin === 1) && (
        <Tooltip placement='top' hasArrow label='Copiar'>
          <span>
            <ButtonHeaderModule
              className='me-1'
              onClick={handleCopy}
              bgColor='#03C39A'
              isLoading={isLoadingButton}
            >
              <IconGeneric
                width='16px'
                className='text-white'
                as={MdContentCopy}
              />
            </ButtonHeaderModule>
          </span>
        </Tooltip>
      )}

      {authUser.is_qualified_user !== 1 &&
        (hasCommonElements(permissionList, changeStatusOutputForm) ||
          authUser.admin === 1) && (
          <Tooltip placement='top' hasArrow label='Descaducar'>
            <span>
              <ButtonHeaderModule bgColor='#F9A621' onClick={handleDescaducar} isLoading={isLoadingButton}>
                <IconGeneric
                  className='text-white'
                  width='16px'
                  as={MdOutlineAssignmentReturn}
                />
              </ButtonHeaderModule>
            </span>
          </Tooltip>
        )}
    </>
  )
}
